import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ContentItem } from './variation_content_preview';
import LibraryDialog from './shared/libraryDialog'; 
import { detachPractice } from '../services/practices';

const PracticeContentPreview = ({ practiceData, setPracticeData, libraries }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [hoveredItem, setHoveredItem] = useState(null);
  const [pickItem, setPickItem] = useState(null);
  const [isTemplateActive, setIsTemplateActive] = useState(false);

  useEffect(() => setIsTemplateActive(!!practiceData?.practice_template_id), [practiceData?.practice_template_id]); 

  const deleteItem = position => {
    let updatedExercises = [...practiceData.exercises_practices_attributes];
    const item = updatedExercises.find(item => item.position === position);

    if (item.id) {
      let index = updatedExercises.findIndex(el => el.position === position);
      updatedExercises.splice(index, 1, { id: item.id, position, _destroy: true });
    } else {
      updatedExercises = updatedExercises.filter(item => item.position !== position);
    }

    setPracticeData({ ...practiceData, exercises_practices_attributes: updatedExercises });
  };

  const handleChangeItem = (practicable_type, item) => {
    const collectionItem = {...item, practicable_type, practicable_id: item?.id, position: pickItem, id: null, _destroy: false};

    let exercises_practices_attributes = [...practiceData.exercises_practices_attributes];

    let index = practiceData.exercises_practices_attributes.findIndex(el => el?.position === pickItem);
    if (index !== -1) {
      exercises_practices_attributes.splice(index, 1, {...collectionItem, id: exercises_practices_attributes[index].id});
    } else {
      exercises_practices_attributes.push(collectionItem);
    }

    setPracticeData({ ...practiceData, exercises_practices_attributes });
    setPickItem(null);
  };

  const detach = async () => {
    try {
      const { practice } = await detachPractice(practiceData.id);
      setPracticeData(practice); 
      setIsTemplateActive(false);
    } catch (error) {
      console.error('Error detaching practice:', error);
    }
  };
  
  const practices = isTemplateActive ? practiceData?.practice_template?.exercises_practices : practiceData?.exercises_practices_attributes;
  
  return (
    <div className='form-container-area'>
      <div className="form-container-area-group flex-between">
        <div className="flex-column">
          <div className="heading">{hoveredItem?.title || t('practice_templates.variations_order')}</div>
          <div className="variation-order-preview">
            <div className={`variation-order-preview-full_size ${hoveredItem ? 'make-visible' : ''}`}>
              <ContentItem {...{ item: hoveredItem, height: 320, width: 320, type: hoveredItem?.practicable_type }} />
            </div>
            <div className="variation-order-preview-list">
              {[1, 2, 3, 4, 5, 6].map(position => {
                const item = practices?.find(
                  el => el.position === position && el._destroy !== true
                );
                return (
                  <div key={position} className="variation-order-preview-list-item">
                    <div>{!item ? `${position}. ${t('practice_templates.choose_exercises')}` : <div># {item?.title}</div>}</div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        <div>
          <div className="heading">{t('practice_templates.choose')}</div>
          <div className="practice-template-collection-items">
            {isTemplateActive && <div className="practice-template-collection-items-overlay">
              <div className="practice-template-collection-items-overlay-button-container">
                <button className="button button-add" onClick={detach}>{t('teams.update_practice')}</button>
                <button className="button button-add" onClick={() => navigate(`/club_admin/practice_templates/${practiceData?.practice_template_id}`)}>
                  {t('teams.update_template')}
                </button>
              </div>
            </div>}
            {[1, 2, 3, 4, 5, 6].map(position => {
              const item = practices?.find(
                el => el.position === position && el._destroy !== true
              );
              return (
                <div
                  key={position}
                  className="variation-manage-item"
                  onMouseOver={() => item && setHoveredItem(item)}
                  onMouseLeave={() => setHoveredItem(null)}
                >
                  <div className="variation-manage-item-controls">
                    <button className="button button-primary" onClick={() => setPickItem(position)}>
                      {!item ? t('common.add') : t('common.change')}
                    </button>
                    {item && (
                      <button className="button button-delete" onClick={() => deleteItem(position)}>
                        {t('common.remove')}
                      </button>
                    )}
                  </div>
                  <ContentItem {...{ item, height: 158, width: 158, type: item?.practicable_type }} />
                </div>
              );
            })}
          </div>
        </div>
      </div>
      {pickItem !== null && (
        <LibraryDialog close={() => setPickItem(null)} onChange={handleChangeItem} libraries={libraries} />
      )}
    </div>
  );
};

export default PracticeContentPreview;